import React from "react";
import { parseISO } from "date-fns";

import Typography from "@material-ui/core/Typography";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

interface IProps {
  date: string;
  facility: racehorse360.IFacility;
}

const ScheduleMiniBox = (props: IProps) => {
  const { date, facility } = props;

  const classes = useStyles({
    backgroundColor: facility?.backgroundColor,
    strokeColor: facility?.strokeColor
  });

  return (
    <div className={classes.box}>
      <Typography className={classes.date}>
        {parseISO(date).getDate()}
      </Typography>
    </div>
  );
};

export default ScheduleMiniBox;
